export type ProductKind = "normal" | "voucher" | "certificate";

export type ProductKindFlags = {
  isVoucher?: boolean | null;
  isCertificate?: boolean | null;
};

export const getProductKind = (product: ProductKindFlags): ProductKind => {
  if (product.isCertificate) return "certificate";
  if (product.isVoucher) return "voucher";
  return "normal";
};

export const cartAcceptsKind = (
  cartKinds: readonly ProductKind[],
  kind: ProductKind,
): boolean => cartKinds.length === 0 || cartKinds.every((k) => k === kind);

export const CERTIFICATE_EMAIL_NOTICE =
  "При заказе укажите email, который использовался при покупке купона — к нему привязываются коды при активации.";
